import { titleCase } from 'change-case'
import React, { Fragment } from 'react'
import { useTheme } from '@opallabs/hooks'
import { kuiperClassNames } from '@opallabs/kuiper'
import * as styles from './styles'

export type PostOption = {
  group_name: string
  group_options: Array<
    Array<{
      option_position: number
      option_title: string
      option_value: string[] | string | number | boolean
    }>
  >
}

type PostOptionDetailsProps = {
  postOptions: Array<PostOption>
}

export const PostOptionDetails: React.FC<PostOptionDetailsProps> = ({
  postOptions,
}) => {
  const theme = useTheme()

  return (
    <Fragment>
      {postOptions.map((option, i) => (
        <div
          className={kuiperClassNames('post-option-group')}
          key={`optionGroup${i}`}
        >
          {option.group_options.map((groupOption, j) => {
            const groupName = option.group_name
            const groupPosition = option.group_options.length > 1 ? j + 1 : null

            return (
              <div
                css={styles.optionGroupSection(theme)}
                className={kuiperClassNames('option-group-section')}
                key={`${groupName}-section-${j}`}
              >
                <div
                  css={styles.groupText}
                  className={kuiperClassNames('group-name')}
                >
                  {groupName} {groupPosition}
                </div>
                {groupOption.map((postOption, k) => {
                  if (!postOption) return null

                  const optionTitle =
                    postOption.option_title === option.group_name
                      ? ''
                      : postOption.option_title
                  const optionValue = Array.isArray(postOption.option_value)
                    ? postOption.option_value
                        .filter((value) => value !== '')
                        .join(', ')
                    : typeof postOption.option_value === 'string' &&
                        !isNaN(Date.parse(postOption.option_value)) &&
                        isNaN(Number(postOption.option_value))
                      ? postOption.option_value
                      : titleCase(String(postOption.option_value))

                  return (
                    <Fragment key={`${groupName}-value-${k}`}>
                      {Boolean(optionTitle) && (
                        <div
                          css={styles.optionTitle}
                          className={kuiperClassNames('option-title')}
                        >
                          {optionTitle.replace(/{{.+}}\s?/g, '')}
                        </div>
                      )}
                      <div
                        css={styles.optionValue(theme)}
                        className={kuiperClassNames('option-value')}
                      >
                        {optionValue}
                      </div>
                    </Fragment>
                  )
                })}
              </div>
            )
          })}
        </div>
      ))}
    </Fragment>
  )
}
